/**
 * Inventory Hub data namespace — keeps Firestore + Storage
 * isolated when sharing a Firebase project with other apps.
 */
export const APP_NAMESPACE = 'inventory-hub';

/** Top-level Firestore collections */
export const COLLECTIONS = {
  users: 'inv_users',
  products: 'inv_products',
  categories: 'inv_categories',
  counters: 'inv_counters',
  settings: 'inv_settings',
};

/**
 * Subcollection ids under inv_users / inv_products.
 * Orders use a unique name so collectionGroup queries
 * do not pick up another app's "orders" subcollections.
 */
export const SUBCOLLECTIONS = {
  orders: 'inv_orders',
  cart: 'cart',
  inventoryHistory: 'inventory_history',
  serialItems: 'serialItems',
};

/** Build a Storage object path under inventory-hub/ */
export function storagePath(...parts) {
  return [APP_NAMESPACE, ...parts.filter(Boolean)].join('/');
}
